/**
 * System Boot Effect for Title Template
 * Creates a cinematic boot sequence with glitching, typing, and status messages
 */

export function startSystemBootEffect(containerEl) {
  if (!containerEl) return () => {};

  const timeouts = [];
  const intervals = [];

  // Find elements
  const logoContainer = containerEl.querySelector('.boot-logo-container');
  const tagline = containerEl.querySelector('.boot-tagline');
  const statsContainer = containerEl.querySelector('.boot-stats');
  const statusMessages = containerEl.querySelector('.boot-status-messages');

  if (!logoContainer || !tagline || !statsContainer || !statusMessages) {
    return () => {};
  }

  // Sequence timing
  const LOGO_GLITCH_START = 0;
  const LOGO_GLITCH_DURATION = 1200;
  const TAGLINE_START = 1400;
  const STATUS_START = 1600;
  const STATS_START = 2400;

  // 1. Logo glitch-in effect
  timeouts.push(setTimeout(() => {
    logoContainer.classList.add('glitching');
    
    timeouts.push(setTimeout(() => {
      logoContainer.classList.remove('glitching');
      logoContainer.classList.add('stable');
    }, LOGO_GLITCH_DURATION));
  }, LOGO_GLITCH_START));

  // 2. Tagline typing effect
  timeouts.push(setTimeout(() => {
    const text = 'WORK THE FUTURE';
    let charIndex = 0;
    
    tagline.textContent = '';
    tagline.style.opacity = '1';
    
    const intervalId = setInterval(() => {
      if (charIndex < text.length) {
        tagline.textContent = text.substring(0, charIndex + 1);
        charIndex++;
      } else {
        clearInterval(intervalId);
      }
    }, 80);
    
    intervals.push(intervalId);
  }, TAGLINE_START));

  // 3. Status messages sequence
  const statusSequence = [
    { text: '> INITIALIZING PREDICTION SYSTEM...', delay: STATUS_START },
    { text: '> LOADING MODEL ARCHITECTURE...', delay: STATUS_START + 600 },
    { text: '> CALIBRATING PARAMETERS...', delay: STATUS_START + 1200 },
    { text: '> SYSTEM READY', delay: STATUS_START + 1800, final: true }
  ];

  statusSequence.forEach((status) => {
    timeouts.push(setTimeout(() => {
      const line = document.createElement('div');
      line.className = 'status-line';
      if (status.final) line.classList.add('final');
      line.textContent = status.text;
      statusMessages.appendChild(line);
      
      // Fade in
      setTimeout(() => line.classList.add('visible'), 10);
    }, status.delay));
  });

  // 4. Stats reveal (already has counting animation)
  timeouts.push(setTimeout(() => {
    statsContainer.classList.add('visible');
  }, STATS_START));

  // Cleanup
  return () => {
    timeouts.forEach((id) => clearTimeout(id));
    intervals.forEach((id) => clearInterval(id));
  };
}
